"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScenarioType;
(function (ScenarioType) {
    ScenarioType["EVENTS"] = "occhatsdk_events";
    ScenarioType["IC3CLIENT"] = "occhatsdk_ic3clientevents";
    ScenarioType["OCSDK"] = "occhatsdk_ocsdkevents";
    ScenarioType["ACSCLIENT"] = "occhatsdk_acsclientevents";
    ScenarioType["ACSADAPTER"] = "occhatsdk_acsadapterevents";
    ScenarioType["CALLINGSDK"] = "occhatsdk_callingsdkevents";
    ScenarioType["AMSCLIENT"] = "occhatsdk_amsclientevents";
    ScenarioType["UNDEFINED"] = "undefined";
})(ScenarioType || (ScenarioType = {}));
exports.default = ScenarioType;
//# sourceMappingURL=ScenarioType.js.map